import * as React from 'react';
import * as styles from './ProjectFullCard.module.scss';
import { ArrowUpRightIcon } from '../icons/ArrowUpRightIcon';
import clsx from 'clsx';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';

export const ProjectFullCard = ({
  title,
  imageUrl,
  gatsbyImage,
  subtitle,
  altText,
  tags,
  isActive,
  hideAnimation,
  className,
}: {
  title: string;
  altText?: string | null;
  imageUrl?: string | null;
  gatsbyImage?: IGatsbyImageData;
  subtitle: string;
  tags: string[];
  isActive?: boolean;
  hideAnimation?: boolean;
  className?: string;
}) => (
  <div className={clsx(styles.card, className)}>
    {gatsbyImage ? (
      <GatsbyImage image={gatsbyImage!} alt={altText || ''} className={styles.card__image} />
    ) : (
      <img className={styles.card__image} src={imageUrl || ''} alt={title} />
    )}
    <div
      className={clsx(styles.card__desc, isActive && styles.card__desc___active)}
      style={hideAnimation ? { transition: 'none' } : {}}
    >
      <div className={styles.card__titleWrapper}>
        <p className={styles.card__title}>{title}</p>
        <ArrowUpRightIcon className={styles.card__arrowUpRight} />
      </div>
      <p className={styles.card__subtitle}>{subtitle}</p>
    </div>
    <div className={styles.card__footer}>
      {tags.map((tag) => (
        <p key={tag} className={styles.card__tag}>
          {tag}
        </p>
      ))}
    </div>
  </div>
);
